// extracted by mini-css-extract-plugin
export default {"lightHeader":"header_lightHeader__1G0BI","darkHeader":"header_darkHeader__F646p","toolbar":"header_toolbar__RAPj9","linkContainer":"header_linkContainer__nS5Eg"};